var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h4.02v1H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.979 20.452a.503.503 0 0 1-.474-.338L8.979 1 2.474 20.113a.5.5 0 1 1-.948-.322L8.034.678A1.003 1.003 0 0 1 9.42.103c.24.118.42.32.506.574l6.527 19.113a.501.501 0 0 1-.474.662"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.59 13.452H4.383a.5.5 0 0 1 0-1h9.207a.5.5 0 0 1 0 1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.452)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.52 1H.5a.5.5 0 0 1 0-1h3.02a.5.5 0 0 1 0 1",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 20.452h-3.021a.5.5 0 1 1 0-1H17.5a.5.5 0 0 1 0 1M22.5 20.452a.503.503 0 0 1-.474-.338l-4.123-12.08-1.886 5.544a.5.5 0 0 1-.948-.322l1.888-5.543a.998.998 0 0 1 1.387-.575.996.996 0 0 1 .506.573l4.124 12.079a.501.501 0 0 1-.474.662"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.794 15.452H16.92a.5.5 0 0 1 0-1h3.874a.5.5 0 0 1 0 1M23.5 20.452h-1.984a.5.5 0 1 1 0-1H23.5a.5.5 0 0 1 0 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.9c2c3cb7.svg";
export { ForwardRef as ReactComponent };